export default function FileModel($parse) {
  'ngInject';
  return {
    restrict: 'A',
    link: function (scope, element, attrs) {
      let model = $parse(attrs.fileModel);
      let modelSetter = model.assign;

      element.bind('change', function () {
        scope.$apply(function () {
          modelSetter(scope, element[0].files[0]);
        });
      });
    }
  };
};


// WEBPACK FOOTER //
// ./src/credit-request/shared/components/file-model.js